import { gql } from '@apollo/client';

import accountFields from '../fragments/accountFields';

const assetOwnersQuery = gql`
  ${accountFields}
  query AccountAssets($assetId: String!, $skip: Int, $first: Int) {
    accountAssets(
      where: { asset: $assetId, quantity_gt: 0 }
      skip: $skip
      first: $first
    ) {
      id
      quantity
      account {
        ...AccountField
      }
    }
  }
`;

export default assetOwnersQuery;
